import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Button from './Button';

const CancelButton = ({ onClick, type }) => {
  const intl = useIntl();

  return (
    <Button
      buttonText={intl.messages['cancel-button']}
      buttonFor="cancel"
      page=""
      variant="text"
      type={type}
      onClick={onClick}
    />
  );
};

CancelButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['danger', 'neutral'])
};

CancelButton.defaultProps = {
  type: 'danger'
};

export default CancelButton;
